import {API} from 'common/api';
import {parseUserResponse} from 'common/users';
import type {User, UserStreak} from 'iq-auth/types';

export const signup = async (
  email: string,
  password: string,
  firstName: string,
  lastName: string,
): Promise<User> => {
  const data = await API.post('/v1/signup', {
    email,
    password,
    first_name: firstName,
    last_name: lastName,
  });
  if (data?.error) throw new Error(data.error);
  return parseUserResponse(data);
};

export const login = async (email: string, password: string): Promise<User> => {
  const data = await API.post('/v1/login', {email, password});
  if (data?.error) throw new Error(data.error);
  return parseUserResponse(data);
};

export const logout = async (): Promise<void> => {
  await API.get('/v1/logout');
};

export const startResetPassword = async (email: string): Promise<void> => {
  const data = await API.post('/v1/start-reset-password', {email});
  if (data?.error) throw new Error(data.error);
};

export const resetPassword = async (token: string, password: string): Promise<void> => {
  const data = await API.post('/v1/reset-password', {token, password});
  if (data?.error) throw new Error(data.error);
};

// Redeems an enterprise/cohort access code for the authenticated user. The
// session must already be established (call after signup/login completes).
// `email` is the address the code was issued to (`e=` param); the backend
// accepts an empty string and falls back to the session user's email.
export const redeemAccessCode = async (code: string, email?: string): Promise<void> => {
  const data = await API.post('/v1/access-codes/redeem', {
    access_code: code,
    user_email: email ?? '',
  });
  if (data?.error) throw new Error(data.error);
};

export const getUserStreak = async (): Promise<UserStreak | null> => {
  const data = await API.get('/v1/users/stats');
  if (data?.error) return null;
  return data.streak as UserStreak;
};
